import axios from "axios";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { current: Object };

  connect() {
    initAccountChartsFiltersForm();
    initSeeDetailsButtons();
    this.loadChart();
  }

  loadChart() {
    let url = this.data.get("url");
    let chartPanelId = "#" + this.data.get("chart-panel-id");
    let filterParams = filtersParams();
    setFiltersDescription();

    if (url) {
      showLoaderPanel(chartPanelId);
      this.clearAndRedraw();

      axios
        .get(url, {
          headers: { Accept: "application/json" },
          params: filterParams
        })
        .then(response => {
          var data = response.data;
          let type = this.data.get("type");

          if ($.isEmptyObject(data.chart_data)) {
            showNoResultsPanel(chartPanelId);
          } else {
            showChartPanel(chartPanelId);

            this.currentValue = data;

            switch (type) {
              case "monthly-data-usage":
                initMonthlyDataUsageDatatable(data);
                initMonthlyDataUsageChart(data);
                break;
              case "call-types-summary":
                initCallTypesSummaryChart(data);
                initCallTypesSummaryDatatable(data);
                break;
              case "cost-centres-summary":
                initCostCentresSummaryChart(data, type);
                initCostCentresSummaryDatatable(data);
                break;
              case "call-services-summary":
                initCallServicesSummaryChart(data, type);
                initCallServicesSummaryDatatable(data);
                break;
              case "call-dates-summary":
                initCallDatesSummaryChart(data, type);
                initCallDatesSummaryDatatable(data);
                break;
              case "call-time-of-day-summary":
                initCallTimeOfDaySummaryChart(data, type);
                initCallTimeOfDaySummaryDatatable(data);
                break;
              case "most-called-numbers":
                initMostCalledNumbersChart(data);
                initMostCalledNumbersDatatable(data);
                break;
              case "longest-calls":
                initLongestCallsChart(data);
                initLongestCallsDatatable(data);
                break;
              case "monthly-mobile-data-usage":
                initMonthlyMobileDataUsageChart(data);
                initMonthlyMobileDataUsageDatatable(data);
                break;
              case "mobile-data-usage-by-period":
                initMobileDataUsageByPeriodDatatable(data);
                initMobileDataUsageByPeriodChart(data);
                break;
              case "mobile-data-usage-by-day":
                initMobileDataUsageByDayChart(data);
                initMobileDataUsageByDayDatatable(data);
                break;
              case "mobile-data-usage-by-time":
                initMobileDataUsageByTimeChart(data);
                initMobileDataUsageByTimeDatatable(data);
                break;
              case "cost-centre-overview":
                initCostCentreOverviewChart(data);
                initCostCentreOverviewDatatable(data);
                this.display_footer_message();
                break;
              case "answer-point":
                initAnswerPointChart(data);
                initAnswerPointDatatable(data);
                this.display_footer_message();
                break;
            }
          }
        })
        .then(() => {
          resetFilterSubmitButton();
        })
        .catch(error => {
          showCardLoadError(this.element, error);
        });
    }
  }

  display_footer_message() {
    if (parseInt(filtersParams()["filters[bill_run_no]"]) > 0) {
      $(".chart-footer").hide();
    } else {
      $(".chart-footer-message").html(
        "For current period only call usage is shown"
      );
      $(".chart-footer").show();
    }
  }

  export(event) {
    const chart_name = this.data.get("type");
    const currentData = this.currentValue;
    exportCsv(chart_name, currentData);
  }

  clearAndRedraw() {
    $(".material-datatables").hide();
    if ($.fn.dataTable.isDataTable(".chart-datatable-content")) {
      $(".chart-datatable-content").DataTable().destroy();
    }
  }
}
